import React, { useContext, useState } from "react";

import { useFormikContext } from "formik";
import { Collapse, IconButton, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { marshalV2 } from "pages/eligibility/marshal";

import formData from "pages/eligibility/components/context/form-data";
import { FormValues } from "pages/eligibility/type";
import Development from "components/development";
import { CopyButton } from "components/haven-design/copy-button";

export const CodeBlock: React.FC<{title: string, code: string}> = ({ title, code }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Grid size={{ md: 12 }}>
      <h3>
        {title}
        <IconButton onClick={handleToggle}>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <CopyButton text={code} />
      </h3>
      <Collapse in={isOpen}>
        <pre><code>{code}</code></pre>
      </Collapse>
    </Grid>
  );
};

const ValueDebugger: React.FC = () => {
  const form = useContext(formData);
  if (!form) return null;
  const { questions } = form;

  const { values } = useFormikContext();

  return (
    <Development>
      <Grid container>
        <CodeBlock
          title="All Form Values"
          code={JSON.stringify(values, null, 2)}
        />

        <CodeBlock
          title="Marshaled Values"
          code={JSON.stringify(marshalV2(questions, values as FormValues[]), null, 2)}
        />
      </Grid>
    </Development>
  );
};

export default ValueDebugger;
